'use strict';

var SettingsOrgUsersController = require('./SettingsOrgUsersController');
var SettingsOrgUserDetailsController = require('./SettingsOrgUserDetailsController');

angular
  .module('settings.orgUsers', ['ngTable'])
  .controller('SettingsOrgUsersController', SettingsOrgUsersController)
  .controller('SettingsOrgUserDetailsController', SettingsOrgUserDetailsController);


// WEBPACK FOOTER //
// ./src/app/settings/orgUsers/index.js